var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m4"},[_c('NextTrainings')],1),_c('div',{staticClass:"col s12 m8"},[_c('Player'),_c('Calendar')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }